module.exports = __webpack_public_path__ + "img/sign.5ba3b6c8.jpg";